// accordions
(function(){
    function initAccordions(){
        const accordions = document.querySelectorAll('.accordion-wrapper');
        accordions.forEach(accordion =>{
            accordion.addEventListener('click',()=>{
                accordion.classList.toggle('open');
            })
        })
    }

    initAccordions()
})();